(() => {
  const translateAppLabels = (root = document) => {
    const titles = root.matches?.('svg title') ? [root] : root.querySelectorAll?.('svg title') || [];
    titles.forEach((title) => {
      const match = title.textContent.trim().match(/^(\d+) reviews?$/i);
      if (match) title.textContent = `${match[1]} ביקורות`;
    });

    const selector = 'a[href="#looxReviewsFrame"][aria-label="Scroll to reviews"]';
    const reviewLinks = root.matches?.(selector) ? [root] : root.querySelectorAll?.(selector) || [];
    // Let the visible rating and review count form the accessible link name.
    reviewLinks.forEach((link) => link.removeAttribute('aria-label'));
  };

  let pending = false;
  const addedRoots = new Set();
  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) addedRoots.add(node);
        else if (record.target.matches?.('svg title')) addedRoots.add(record.target);
      });
    });
    if (!addedRoots.size) return;
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      // Only inspect new subtrees, not the entire page after every app update.
      addedRoots.forEach((root) => {
        if (root.isConnected) translateAppLabels(root);
      });
      addedRoots.clear();
      pending = false;
    });
  });

  const initialize = () => {
    translateAppLabels();
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
